import React, { useState } from "react";
import { Button, Container, Row } from "reactstrap";

const style={
  button:{
    width:215
  }
}

const CallToAction = (props) => {

  return (
        <Container >
          <Row className="text-center mt-5 mb-5">
            <div className="col-sm">
              <Button
                className="btn-call-to-action"
                color="primary"
                onClick={props.handleIndicadores}
                style={style.button}
              >
                INDICADORES
              </Button>
            </div>
            <div className="col-sm">
              <Button
                className="btn-call-to-action"
                color="primary"
                onClick={props.handleRelatorios}
                style={style.button}
              >
                RELATÓRIOS
              </Button>
            </div>
            <div className="col-sm">
              <Button
                className="btn-call-to-action"
                color="primary"
                onClick={props.handlePaineisControle}
                style={style.button}
              >
                PAINÉIS DE CONTROLE
              </Button>
            </div>
            <div className="col-sm">
              <Button
                className="btn-call-to-action"
                color="primary"
                onClick={props.handleMapas}
                style={style.button}
              >
                MAPAS
              </Button>
            </div>
            <div className="col-sm">
              <Button
                className="btn-call-to-action"
                color="primary"
                onClick={props.handleFaleConosco}
                style={style.button}
              >
                FALE CONOSCO
              </Button>
            </div>

          </Row>
        </Container>

  );
};

export default CallToAction;
